import styled from '@emotion/styled'

export const SkeletonWrapper = styled.div`
  display: grid;
  grid-row-gap: 1em;
`
